import React from 'react';
import { useLang } from '../LanguageContext';

export default function BugActivity({ bug, showAll, toggleShowAll, formatDate }) {
  const { t } = useLang();
  const commentsDesc = Array.isArray(bug.comments)
    ? [...bug.comments].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    : [];
  const lastComment = commentsDesc[0];

  return (
    <div className="mb-2 mt-2">
      {lastComment ? (
        <>
          <small className="text-muted d-block">
            {formatDate(lastComment.createdAt)} - {lastComment.author || 'Unknown'}
          </small>
          <p className="mb-1">{lastComment.text}</p>
        </>
      ) : (
        <small className="text-muted">{t('noCommentsYet')}</small>
      )}
      <button
        className="btn btn-sm btn-link p-0"
        onClick={(e) => {
          e.stopPropagation();
          toggleShowAll();
        }}
      >
        {t('showAllComments')} 💬 {bug.comments?.length || 0}
      </button>
      {showAll && commentsDesc.length > 0 && (
        <div className="mt-2">
          {commentsDesc.map((c, idx) => (
            <div key={idx} className="border-top pt-1">
              <small className="text-muted d-block">
                {formatDate(c.createdAt)} - {c.author || 'Unknown'}
              </small>
              <p className="mb-1">{c.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
